import { Col, Collapse, Row } from 'antd';
import { AntPageTitle } from 'components/ui/AntPageTitle';
import { Fragment } from 'react';
import { useParams } from 'react-router-dom';
const { Panel } = Collapse;

export const ReleaseNotesPage = (): JSX.Element => {
  const { version } = useParams();

  return (
    <Fragment>
      <Row justify="space-between" style={{ padding: 10, background: 'rgb(255, 234, 193)', borderRadius: 5 }}>
        <Col>
          <AntPageTitle text={'Release Notes'} />
        </Col>
      </Row>
      <Collapse defaultActiveKey={['4.1']}>
        <Panel header="Version 4.1" key="4.1">
          <div>General</div>
          <ol>
            <li>Inventory reservation settings will now be sent to D365 based on the customer&apos;s chosen deployment request type.</li>
            <li>A release notes page has been added to the website.</li>
            <li>Sparing request types can now require Return Part Number and Return Serial Number to be entered for defective returns before a request is submitted.</li>
          </ol>
        </Panel>
      </Collapse>
    </Fragment>
  );
};
